const variables = {
  colors: {
    torchRed: `#FF004E`,
    bottleGreen: `#082129`,
    daintree: `#002630`,
    catskillWhite: `#DDE8EE`,
  }
}

export default variables